import { Avatar, Box, IconButton, Stack, Typography } from '@mui/material'
import React from 'react'
import toast from 'react-hot-toast'
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined'
import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined'
import LockPersonOutlinedIcon from '@mui/icons-material/LockPersonOutlined'
import EditIcon from '@mui/icons-material/Edit'
import LinkIcon from '@mui/icons-material/Link'

export interface BrandTeamMemberProps {
  data: any
  onDelete: (param: any) => void
  onChangeAdmin: (param: any) => void
  onEdit?: (param: any) => void
}
const DEFAULT_SHORT_DESCRIPTION = '-'
export function BrandTeamMember({ data, onDelete, onChangeAdmin, onEdit }: BrandTeamMemberProps) {
  if (!data) {
    return null;
  }

  return (
    <Box
      padding={3}
      sx={{
        backgroundColor: 'var(--surface-2)',
        borderRadius: '8px',
        border: '1px solid var(--border)',
      }}
    >
      <Stack direction="row" spacing={3} alignItems="center" justifyContent="space-between">
        <Stack spacing={1} alignItems="flex-start" direction="row">
          {data.avatar ? <Avatar src={data.avatar} /> : <Avatar>{data.displayName?.[0] || data.emailAddress?.split('@')[0]?.[0] || '?'}</Avatar>}
          <Box>
            <Typography fontSize={16} fontWeight="bold" marginBottom={0.5}>
              {data.displayName || `${data.firstName || ''} ${data.lastName || ''}`.trim() || data.emailAddress?.split('@')[0] || 'Unknown User'}
            </Typography>
            <Typography fontSize={14} color="text.secondary" marginBottom={0.5}>
              {data.emailAddress || 'No email provided'}
            </Typography>
            <Typography fontSize={14} color="text.secondary">
              {data.usertype || 'Unknown role'}
            </Typography>
          </Box>
        </Stack>
        <Stack direction="row" spacing={1}>
          {onEdit && (
            <IconButton
              size="small"
              onClick={() => onEdit(data)}
              sx={{ color: 'var(--text-2)' }}
            >
              <EditIcon fontSize="small" />
            </IconButton>
          )}

          <IconButton
            size="small"
            sx={{ color: 'var(--text-2)' }}
            onClick={() => {
              navigator.clipboard.writeText(`https://portal.thedesirecompany.com/register/${data.displayName || data.emailAddress}`);
            }}
          >
            <LinkIcon fontSize="small" />
          </IconButton>

          {data.usertype !== 'brand admin' && (
            <IconButton
              size="small"
              sx={{ color: 'var(--text-2)' }}
              onClick={() => onChangeAdmin(data)}
            >
              <AdminPanelSettingsOutlinedIcon fontSize="small" />
            </IconButton>
          )}

          {data.usertype !== 'brand admin' && (
            <IconButton
              size="small"
              sx={{ color: 'error.main' }}
              onClick={() => onDelete(data)}
            >
              <DeleteOutlineOutlinedIcon fontSize="small" />
            </IconButton>
          )}

          {data.usertype === 'brand admin' && (
            <IconButton
              size="small"
              sx={{ color: 'var(--text-2)' }}
              onClick={() => { toast("This is the brand's admin.") }}
            >
              <LockPersonOutlinedIcon fontSize="small" />
            </IconButton>
          )}
        </Stack>
      </Stack>
    </Box>
  );
}
